package com.dotpx.ambient

internal actual fun platformControllerAudioPolicy(): ControllerAudioPolicy = DefaultControllerAudioPolicy
